import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./assets/styles/sidebars.css";
import { routes } from "./Routes";
import { MainLayout } from "./components";
import config from "./config";
import MaintenanceBoard from "./components/common/MaintenanceBoard";

function App() {
  const maintenanceEnabled = config.maintenance?.enabled === true;

  if (maintenanceEnabled) {
    return <MaintenanceBoard />;
  }

  return (
    <Router>
      <Routes>
        {routes.loginLayout.map((route, index) => (
          <Route
            key={`ll_${index}`}
            path={route.path}
            element={route.element}
          />
        ))}

        {routes.noSidebarLayout.map((route, index) => (
          <Route
            key={`nsl_${index}`}
            path={route.path}
            element={route.element}
          />
        ))}

        <Route element={<MainLayout />}>
          {routes.mainLayout.map((route, index) => (
            <Route
              key={`ml_${index}`}
              path={route.path}
              element={route.element}
            />
          ))}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
